export enum ELoginType {
    GOOGLE = 'GOOGLE',
    FACEBOOK = 'FACEBOOK',
    APPLE = 'APPLE',
    APPLE_FINISH = 'APPLE_FINISH',
    APPLE_IOS_APP = 'APPLE_IOS_APP',
    EMAIL = 'EMAIL'
}

export interface IConfig {
    ApiBaseUrl: string;
    FacebookAppId: string;
    GoogleClientId: string;
    Environment: string;
    GoogleMapsApiKey: string;
    GoogleCaptchaKey: string;
    AppleClientId: string;
    AppleLoginReturnUri: string;
    AppleRegisterReturnUri: string;
    RoutesConfig: string;
    GoogleAnalyticsCode: string;
    AmplitudeApiKey: string;
    StaticContentUrl: string;
}

export enum EToastType {
    SUCCESS,
    ERROR,
    WARNING
}
